<template>
  <div class="page-log">
    <el-card shadow="never">
      <el-form :inline="true" class="filter-form" @submit.native.prevent="search">
        <el-form-item label="查询码">
          <el-input v-model.trim="filterCode" clearable placeholder="模糊筛选" style="width: 200px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="list" border stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="queryCode" label="查询码" min-width="110" show-overflow-tooltip />
        <el-table-column prop="certificateId" label="证书ID" width="90" />
        <el-table-column label="查询时间" min-width="170">
          <template slot-scope="scope">
            {{ formatTime(scope.row.queriedAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="ipAddress" label="IP" width="130" show-overflow-tooltip />
        <el-table-column prop="userAgent" label="User-Agent" min-width="200" show-overflow-tooltip />
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="size"
        :current-page.sync="page"
        @current-change="fetchList"
      />
    </el-card>
  </div>
</template>

<script>
import { queryLogPageApi } from '../api/queryLog'

export default {
  name: 'QueryLogManage',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      size: 10,
      filterCode: ''
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatTime(v) {
      if (v == null || v === '') return '—'
      if (typeof v === 'string') {
        const s = v.trim()
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) return s
        const t = Date.parse(s)
        if (!Number.isNaN(t)) {
          const d = new Date(t)
          const fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Shanghai',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          })
          const parts = fmt.formatToParts(d)
          const m = {}
          parts.forEach(({ type, value }) => {
            if (type !== 'literal') m[type] = value
          })
          return `${m.year}-${m.month}-${m.day} ${m.hour}:${m.minute}:${m.second}`
        }
        return s
      }
      return String(v)
    },
    search() {
      this.page = 1
      this.fetchList()
    },
    resetFilter() {
      this.filterCode = ''
      this.page = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.page - 1, size: this.size }
        if (this.filterCode) params.queryCode = this.filterCode
        const res = await queryLogPageApi(params)
        const d = res.data || {}
        this.list = d.content || []
        this.total = d.totalElements || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-form {
  margin-bottom: 12px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
